import { Sparkles, Mail } from "lucide-react";

const CONTACT_EMAIL = "infoosintquebec@gmail.com";

const SaleBanner = () => {
  return (
    <>
      {/* Top slim banner — always visible on public pages */}
      <div
        data-testid="sale-banner"
        className="w-full bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 text-white text-center py-2 px-2 sm:px-4 shadow-lg relative z-50 sale-banner-flash"
      >
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-4 text-[11px] sm:text-sm md:text-[15px] font-medium">
          <span className="flex items-center gap-1.5 sm:gap-2 flex-wrap justify-center">
            <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
            <span className="font-bold">FR:</span>
            <span>Plateforme <strong>à vendre</strong> — <span className="hidden sm:inline">Prête pour distribution et mise en marché internationale</span><span className="sm:hidden">Prête pour distribution</span></span>
          </span>
          <span className="hidden sm:inline text-white/60">•</span>
          <span className="flex items-center gap-1.5 sm:gap-2 flex-wrap justify-center">
            <span className="font-bold">EN:</span>
            <span>OSINT Platform <strong>for sale</strong> — <span className="hidden sm:inline">Ready for international distribution &amp; go-to-market</span><span className="sm:hidden">Ready for intl. distribution</span></span>
          </span>
          <a
            href={`mailto:${CONTACT_EMAIL}?subject=Acquisition%20de%20la%20plateforme%20SNE%20-%20SNE%20Platform%20acquisition&body=Bonjour%2C%0A%0AJe%20suis%20int%C3%A9ress%C3%A9(e)%20par%20l%27acquisition%20de%20la%20plateforme%20SNE.%0A%0AHello%2C%0A%0AI%20am%20interested%20in%20acquiring%20the%20SNE%20platform.%0A%0A`}
            data-testid="sale-banner-contact-link"
            className="inline-flex items-center gap-1 sm:gap-1.5 bg-black/25 hover:bg-black/40 px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full transition-colors font-semibold whitespace-nowrap text-[11px] sm:text-sm"
          >
            <Mail className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
            Contact
          </a>
        </div>
      </div>

      <style>{`
        @keyframes saleBannerFlash {
          0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(245, 158, 11, 0); }
          50% { opacity: 0.85; box-shadow: 0 0 24px rgba(245, 158, 11, 0.6); }
        }
        .sale-banner-flash {
          animation: saleBannerFlash 3.2s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .sale-banner-flash { animation: none; }
        }
      `}</style>
    </>
  );
};

export default SaleBanner;
